import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["collaborator"],
  _excluded2 = ["collaborator"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Map from "@babel/runtime-corejs3/core-js/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js/instance/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import { cloneDeep, isEmpty, map, reduce, sortBy, values, find, pick } from "lodash";
import moment from "moment";
import Vue from "vue";
import { SET_BOARDS, SET_BOARD, SET_BOARD_COLLABORATORS, SET_BOARD_CLIENTS, SET_BOARD_STATUSES, SET_BOARD_CLIENT, SET_BOARD_STATUS_ORDER, SET_DEFAULT_BOARD_ID, INCREMENT_BOARD_CLIENTS, DECREMENT_BOARD_CLIENTS, ADD_BOARD_STATUS, SET_BOARD_STATUS, REMOVE_BOARD_STATUS, SET_BOARD_ORDER, MOVE_PROFILES_TO_COLUMN, REMOVE_CLIENT_BOARD, SET_TRACK_EMAILS, SET_COLLABORATOR_DETAILS, SET_CLIENT_PROFILE_CARD_COLOR, REMOVE_CLIENT_PROFILE, ADD_BOARD_CLIENT_REMINDERS, SET_BOARD_CLIENT_REMINDERS, SET_BOARD_COLLABORATOR, REMOVE_BOARD_COLLABORATOR, EDIT_CLIENT_PROFILE_REMINDER, REMOVE_COMPLETE_CLIENT_PROFILE_REMINDERS, SET_ACTIVITY_SORT, SET_ACTIVE_SEARCH_STRING, SET_CUSTOM_FIELDS_DEFINITIONS, SET_CUSTOM_FIELD_TRANSLATION_MAP, ADD_CUSTOM_FIELD_DEFINITION, SET_CUSTOM_FIELD_DEFINITION, SET_CUSTOM_FIELD_ORDER, REMOVE_CUSTOM_FIELD_DEFINITION, SET_BOARD_PROFILE, SET_BOARD_FILTER, SET_PROFILE_NOTIFIED_REFERRERS, SET_EMAIL_TACKING, UPDATE_PROFILE_COLLABORATORS, UPDATE_PROFILE_COLLABORATOR_DETAILS, SET_PROFILE_ACTIVE, SET_TIMELINE_ITEM_DETAILS, SET_CUSTOM_FIELDS_DATA, SET_INACTIVE_PROFILES, SET_INACTIVE_FILTERS, ADD_TIMELINE_ITEM, SET_CHANGELOG, SET_LINKED_USERNAME, ADD_NOTIFIED_REFERRER, REMOVE_NOTIFIED_REFERRER, SET_PROFILE_TIMELINE, SET_TIMELINE_REMAINING, REMOVE_TIMELINE_ITEM, SET_EMAIL_TEMPLATES, ADD_TEMPLATE_ITEM, UPDATE_TEMPLATE_ITEM, REMOVE_TEMPLATE_ITEM, ADD_CO_APPLICANT_ITEM, REMOVE_CO_APPLICANT_ITEM, UPDATE_CO_APPLICANT_ITEM, SET_PROFILE_COLLABORATORS, SET_REFERRER, UPDATE_STATUS_LABEL, UPDATE_UPDATED_AT, UPDATE_PROFILE_OWNER, SET_CLIENT_PROFILE, SET_BOARD_CHANGELOG, SET_CLIENT_LISTS, SET_CLIENT_CAMPAIGNS, REMOVE_CLIENT_PROFILES, SET_PROFILE_MASTER_SUBSCRIBE, SET_CLIENT_PROFILES_WITH_CHANGES, SET_CHANGELOG_LAST_CHANGES, REMOVE_CHANGELOG_LAST_CHANGES, SET_PROFILE_MASTER_SUBSCRIBE_AUTHOR, SET_EMAIL_BODY, SET_PROFILE_STRUCTURE, REMOVE_PROFILE_FROM_ORDER, REMOVE_BOARD_CLIENT_REMINDER, SET_INACTIVE_PROFILE_STRUCTURE, CHANGE_BOARD_TO_DEFAULT, SET_USER_DETAILS, ADD_BOARD, ADD_CHECKLIST_TEMPLATE_ITEM, SET_CHECKLIST_TEMPLATES, REMOVE_CHECKLIST_TEMPLATE_ITEM, SET_PROFILE_PARTICIPANTS } from "./board-mutations";
import { getBoardCollaborators, getBoards, orderBoards, updateProfileDetails, updateStatusOrder, setBoardAsDefault, createBoardStatus, updateBoardStatus, deleteBoardStatus, updateBoard, createBoard, duplicateBoard, deleteBoard, updateCollaboratorSettings, downloadDocument, addNote, addFollowUp, transferClientProfile, addBoardCollaborator, removeBoardCollaborator, updateFollowUp, setBoardSortBy, createNewProfile, getDuplicateClients, getCustomFieldsDeclarations, createCustomFieldDeclaration, updateCustomFieldDeclaration, updateCustomFieldOrder, getNotifiedReferrers, addClientProfileCollaborator, removeProfileCollaborator, updateCollaboratorEmailSync, deleteCustomFieldDeclaration, deleteClientProfile, getChangelog, getProfileDetails, linkApplication, subscribeReferrers, unsubscribeReferrer, getTimeline, togglePin, createChecklist, sendNoteToReferrers, updateNote, saveChecklist, deleteFollowUp, addFollowUpAssignee, deleteFollowUpAssignee, deleteNote, deleteEmail, deleteChecklist, getEmailTemplates, saveEmailTemplate, updateEmailTemplate, deleteEmailTemplate, sendEmail, changeOwner, getProfileCollaborators, duplicateClientProfile, getTemplate, getBoardChangelog, getClientLists, getClientCampaigns, mergeClientProfile, batchTransferClientProfiles, moveEmailAttachment, synchronizeLinkedApplication, changeMasterSubscription, getEmailBody, removeSelfFromBoard, updateProfileLabel, saveChecklistTemplate, deleteChecklistTemplate, getChecklistTemplates, getParticipants, addParticipant, updateParticipant, updateParticipantOrder, deleteParticipant } from "./board-api";
import { getBoardClientProfilePages } from "./board-client-profiles-pagination";
const apiCache = new _Map();
const cacheWithExpiry = (key, data) => {
  apiCache.set(key, {
    data,
    expiry: Date.now() + 5 * 60 * 1000
  });
  return data;
};
const getFromCache = key => {
  const cachedItem = apiCache.get(key);
  if (cachedItem && cachedItem.expiry > Date.now()) {
    return cachedItem.data;
  }
  return null;
};
const invalidateCache = keyPattern => {
  _Array$from(_keysInstanceProperty(apiCache).call(apiCache)).forEach(key => {
    if (typeof key === "string" && _includesInstanceProperty(key).call(key, keyPattern)) {
      apiCache.delete(key);
    }
  });
};
import { getInactiveClients } from "../inactive/api/inactive-api";
import { getOrphanCustomFields, mergeCustomFields } from "@Broker/js/utils/store-helpers/client-profile";
import { VALID_TIMELINE_ITEMS, DEPRECATED_CLIENT_PROFILE_DETAILS } from "@Broker/js/custom/utils";
import { getFormattedScheduledTime } from "@Shared/@Utils/utils";
import { boardsSchema, collaboratorsSchema, clientProfileSchema, customFieldsSchema, emailTemplatesSchema, subscribersSchema, timelineSchema, inactiveClientSchema, checklistTemplatesSchema } from "./board-schema";
import Err from "@Broker/@Routes/error.js";
import { normalize } from "normalizr";
import { openFileDialog } from "@Shared/utils/utils";
import { getSubstitutionsNamesInfo, replaceSubstitutionsTags, setCustomFieldsValues } from "@Broker/js/utils/store-helpers/client-profile";
import { showToast } from "@Shared/utils/constants";
import { getArrayNextItem } from "@Shared/utils/utils";
import Amplitude from "@Shared/utils/amplitude";
import defaultState from "./client-profile-default-state";
import { CUSTOM_FIELDS_DEFINITIONS } from "./board-getters";
import { cacheAction } from "vuex-cache";
import { validate as uuidValidate } from "uuid";
export const LOAD_BOARD_COLLABORATORS = "LOAD_BOARD_COLLABORATORS";
export const LOAD_BOARDS = "LOAD_BOARDS";
export const ORDER_BOARDS = "ORDER_BOARDS";
export const LOAD_BOARD_CLIENTS = "LOAD_BOARD_CLIENTS";
export const MOVE_BOARD_PROFILE = "MOVE_BOARD_PROFILE";
export const LOAD_DEFAULT_BOARD_ID = "LOAD_DEFAULT_BOARD_ID";
export const UPDATE_DEFAULT_BOARD = "UPDATE_DEFAULT_BOARD";
export const UPDATE_BOARD_CLIENTS = "UPDATE_BOARD_CLIENTS";
export const CREATE_STATE_COLUMN = "CREATE_STATE_COLUMN";
export const UPDATE_STATE_COLUMN_CONFIG = "UPDATE_STATE_COLUMN_CONFIG";
export const MOVE_STATUS_COLUMN = "MOVE_STATUS_COLUMN";
export const DELETE_STATUS_COLUMN = "DELETE_STATUS_COLUMN";
export const UPDATE_STATE_COLUMN_LABEL = "UPDATE_STATE_COLUMN_LABEL";
export const CREATE_CLIENT_BOARD = "CREATE_CLIENT_BOARD";
export const DUPLICATE_CLIENT_BOARD = "DUPLICATE_CLIENT_BOARD";
export const UPDATE_CLIENT_BOARD = "UPDATE_CLIENT_BOARD";
export const UPDATE_CLIENT_BOARD_VISIBILITY = "UPDATE_CLIENT_BOARD_VISIBILITY";
export const DELETE_CLIENT_BOARD = "DELETE_CLIENT_BOARD";
export const UPDATE_COLLABORATOR_SETTINGS = "UPDATE_COLLABORATOR_SETTINGS";
export const DOWNLOAD_CSV_EXPORT = "DOWNLOAD_CSV_EXPORT";
export const UPDATE_CLIENT_PROFILE_COLOR = "UPDATE_CLIENT_PROFILE_COLOR";
export const MARK_CLIENT_PROFILE_INACTIVE = "MARK_CLIENT_PROFILE_INACTIVE";
export const CREATE_PROFILE_QUICK_NOTE = "CREATE_PROFILE_QUICK_NOTE";
export const CREATE_QUICK_REMINDER = "CREATE_QUICK_REMINDER";
export const CREATE_PROFILE_QUICK_REMINDER = "CREATE_PROFILE_QUICK_REMINDER";
export const TRANSFER_CLIENT_PROFILE = "TRANSFER_CLIENT_PROFILE";
export const ASSIGN_BOARD_COLLABORATOR = "ASSIGN_BOARD_COLLABORATOR";
export const UNASSIGN_BOARD_COLLABORATOR = "UNASSIGN_BOARD_COLLABORATOR";
export const REMOVE_SELF_FROM_BOARD = "REMOVE_SELF_FROM_BOARD";
export const UPDATE_CLIENT_PROFILE_REMINDER = "UPDATE_CLIENT_PROFILE_REMINDER";
export const CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS = "CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS";
export const UPDATE_BOARD_SORT = "UPDATE_BOARD_SORT";
export const RESET_CURRENT_SEARCH = "RESET_CURRENT_SEARCH";
export const CREATE_CLIENT_PROFILE = "CREATE_CLIENT_PROFILE";
export const LOAD_CUSTOM_FIELDS_DEFINITIONS = "LOAD_CUSTOM_FIELDS_DEFINITIONS";
export const CREATE_CUSTOM_FIELD_DEFINITION = "CREATE_CUSTOM_FIELD_DEFINITION";
export const UPDATE_CUSTOM_FIELD_DEFINITION = "UPDATE_CUSTOM_FIELD_DEFINITION";
export const ORDER_CUSTOM_FIELD_DEFINITION = "ORDER_CUSTOM_FIELD_DEFINITION";
export const TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY = "TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY";
export const DELETE_CUSTOM_FIELD_DEFINITION = "DELETE_CUSTOM_FIELD_DEFINITION";
export const UPDATE_BOARD_PROFILE = "UPDATE_BOARD_PROFILE";
export const UPDATE_BOARD_FILTERS = "UPDATE_BOARD_FILTERS";
export const LOAD_CLIENT_PROFILE_SUBSCRIBERS = "LOAD_CLIENT_PROFILE_SUBSCRIBERS";
export const ADD_PROFILE_COLLABORATOR = "ADD_PROFILE_COLLABORATOR";
export const REMOVE_PROFILE_COLLABORATOR = "REMOVE_PROFILE_COLLABORATOR";
export const TOGGLE_COLLABORATOR_EMAIL_SYNC = "TOGGLE_COLLABORATOR_EMAIL_SYNC";
export const SET_CLIENT_PROFILE_ACTIVE_STATUS = "SET_CLIENT_PROFILE_ACTIVE_STATUS";
export const CHANGE_PROFILE_OWNER = "CHANGE_PROFILE_OWNER";
export const LINK_CLIENT_PROFILE = "LINK_CLIENT_PROFILE";
export const UNLINK_CLIENT_PROFILE = "UNLINK_CLIENT_PROFILE";
export const ASSIGN_REFERRER = "ASSIGN_REFERRER";
export const SUBSCRIBE_REFERRER = "SUBSCRIBE_REFERRER";
export const UNSUBSCRIBE_REFERRER = "UNSUBSCRIBE_REFERRER";
export const LOAD_TIMELINE = "LOAD_TIMELINE";
export const PIN_TIMELINE_ITEM = "PIN_TIMELINE_ITEM";
export const ADD_NOTE = "ADD_NOTE";
export const ADD_CHECKLIST = "ADD_CHECKLIST";
export const SEND_EMAIL_TO_CLIENT = "SEND_EMAIL_TO_CLIENT";
export const ADD_FOLLOW_UP = "ADD_FOLLOW_UP";
export const SEND_NOTE = "SEND_NOTE";
export const EDIT_NOTE = "EDIT_NOTE";
export const EDIT_FOLLOW_UP = "EDIT_FOLLOW_UP";
export const EDIT_CHECKLIST = "EDIT_CHECKLIST";
export const DELETE_FOLLOW_UP = "DELETE_FOLLOW_UP";
export const ADD_FOLLOW_UP_ASSIGNEES = "ADD_FOLLOW_UP_ASSIGNEES";
export const DELETE_FOLLOW_UP_ASSIGNEES = "DELETE_FOLLOW_UP_ASSIGNEES";
export const DELETE_NOTE = "DELETE_NOTE";
export const DELETE_EMAIL = "DELETE_EMAIL";
export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
export const LOAD_EMAIL_TEMPLATES = "LOAD_EMAIL_TEMPLATES";
export const CREATE_EMAIL_TEMPLATE = "CREATE_EMAIL_TEMPLATE";
export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";
export const REMOVE_EMAIL_TEMPLATE = "REMOVE_EMAIL_TEMPLATE";
export const LOAD_CHECKLIST_TEMPLATES = "LOAD_CHECKLIST_TEMPLATES";
export const CREATE_CHECKLIST_TEMPLATE = "CREATE_CHECKLIST_TEMPLATE";
export const REMOVE_CHECKLIST_TEMPLATE = "REMOVE_CHECKLIST_TEMPLATE";
export const ADD_CO_APPLICANT = "ADD_CO_APPLICANT";
export const REMOVE_CO_APPLICANT = "REMOVE_CO_APPLICANT";
export const UPDATE_CO_APPLICANT = "UPDATE_CO_APPLICANT";
export const CHANGE_PROFILE_STATUS = "CHANGE_PROFILE_STATUS";
export const SAVE_PROFILE_DETAILS = "SAVE_PROFILE_DETAILS";
export const DELETE_CLIENT_PROFILE = "DELETE_CLIENT_PROFILE";
export const UPDATE_FOLLOWUP_ASSIGNEE_OWNER = "UPDATE_FOLLOWUP_ASSIGNEE_OWNER";
export const UPDATE_CUSTOM_FIELDS_DATA = "UPDATE_CUSTOM_FIELDS_DATA";
export const MERGE_CUSTOM_FIELDS_DATA = "MERGE_CUSTOM_FIELDS_DATA";
export const LOAD_INACTIVE_CLIENTS = "LOAD_INACTIVE_CLIENTS";
export const LOAD_CHANGELOG = "LOAD_CHANGELOG";
export const LOAD_PROFILE_COLLABORATORS = "LOAD_PROFILE_COLLABORATORS";
export const LOAD_CLIENT_PROFILE_DETAILS = "LOAD_CLIENT_PROFILE_DETAILS";
export const TRANSFER_BOARD_CLIENT_PROFILE = "TRANSFER_BOARD_CLIENT_PROFILE";
export const DUPLICATE_CLIENT_PROFILE = "DUPLICATE_CLIENT_PROFILE";
export const LOAD_EMAIL_TEMPLATE = "LOAD_EMAIL_TEMPLATE";
export const LOAD_BOARD_CHANGELOG = "LOAD_BOARD_CHANGELOG";
export const LOAD_CLIENT_PROFILE_LISTS = "LOAD_CLIENT_PROFILE_LISTS";
export const LOAD_CLIENT_PROFILE_CAMPAIGNS = "LOAD_CLIENT_PROFILE_CAMPAIGNS";
export const MERGE_CLIENT_PROFILE = "MERGE_CLIENT_PROFILE";
export const GET_CLIENT_DUPLICATE = "GET_CLIENT_DUPLICATE";
export const TRANSFER_BOARD_CLIENT_PROFILES = "TRANSFER_BOARD_CLIENT_PROFILES";
export const MOVE_EMAIL_ATTACHMENT = "MOVE_EMAIL_ATTACHMENT";
export const SYNCHRONIZE_LINKED_APPLICATION = "SYNCHRONIZE_LINKED_APPLICATION";
export const CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION = "CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION";
export const LOAD_CLIENT_PROFILES_WITH_CHANGES = "LOAD_CLIENT_PROFILES_WITH_CHANGES";
export const LOAD_EMAIL_BODY = "LOAD_EMAIL_BODY";
export const CACHED_CLIENT_PROFILE_DATA = "CACHED_CLIENT_PROFILE_DATA";
export const UPDATE_PROFILE_LABEL = "UPDATE_PROFILE_LABEL";
export const GET_CLIENT_PROFILE_PARTICIPANTS = "GET_CLIENT_PROFILE_PARTICIPANTS";
export const ADD_CLIENT_PROFILE_PARTICIPANTS = "ADD_CLIENT_PROFILE_PARTICIPANTS";
export const UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT = "UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT";
export const UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER = "UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER";
export const DELETE_CLIENT_PROFILE_PARTICIPANTS = "DELETE_CLIENT_PROFILE_PARTICIPANTS";
const CLIENT_PROFILE_RENDER_CHUNK_SIZE = 50;
const waitForUiWorkSlot = () => new _Promise(resolve => {
  if (typeof window === "undefined") {
    setTimeout(resolve, 0);
    return;
  }
  const requestIdleCallback = window.requestIdleCallback;
  if (requestIdleCallback) {
    requestIdleCallback(() => resolve(), {
      timeout: 100
    });
    return;
  }
  window.requestAnimationFrame(() => {
    setTimeout(resolve, 0);
  });
});
const splitIntoChunks = (items, chunkSize) => {
  const chunks = [];
  for (let index = 0; index < items.length; index += chunkSize) {
    chunks.push(_sliceInstanceProperty(items).call(items, index, index + chunkSize));
  }
  return chunks;
};
const normalizePageClientProfiles = clientProfiles => {
  const normalizedClientProfiles = normalize(clientProfiles, [clientProfileSchema]);
  const profilesById = normalizedClientProfiles.entities.clientProfiles || {};
  clientProfiles.forEach(profile => {
    const normalizedProfile = profilesById[profile.id];
    if (!normalizedProfile) return;
    DEPRECATED_CLIENT_PROFILE_DETAILS.forEach(key => {
      delete normalizedProfile[key];
    });
    const {
      entities,
      result
    } = normalize(profile.collaborators || [], [collaboratorsSchema]);
    normalizedProfile.collaborators = {
      byId: entities.collaborators || {},
      allIds: result
    };
    if ((profile.coApplicants || []).length === 0) {
      normalizedProfile.coApplicants = defaultState().coApplicants;
    }
  });
  return {
    byId: profilesById,
    allIds: normalizedClientProfiles.result
  };
};
const createBoardStatusAccumulator = () => {
  const statusesById = {};
  const statusIds = [];
  const statusOrderById = {};
  const statusOrderSetsById = {};
  const addStatusMetadata = status => {
    const existingStatus = statusesById[status.id];
    if (!existingStatus) {
      statusesById[status.id] = _objectSpread(_objectSpread({}, status), {}, {
        count: 0,
        value: 0,
        order: []
      });
      statusIds.push(status.id);
      return;
    }
    statusesById[status.id] = _objectSpread(_objectSpread(_objectSpread({}, existingStatus), status), {}, {
      count: existingStatus.count,
      value: existingStatus.value,
      order: existingStatus.order
    });
  };
  const addProfileValueToStatus = (statusLabelId, value) => {
    const existingStatus = statusesById[statusLabelId];
    if (!existingStatus) return;
    statusesById[statusLabelId] = _objectSpread(_objectSpread({}, existingStatus), {}, {
      count: existingStatus.count + 1,
      value: existingStatus.value + (_parseInt(`${value}`, 10) || 0)
    });
  };
  const addProfile = ({
    id,
    statusLabelId
  }) => {
    if (!statusOrderById[statusLabelId]) {
      statusOrderById[statusLabelId] = [];
      statusOrderSetsById[statusLabelId] = new _Set();
    }
    if (statusOrderSetsById[statusLabelId].has(id)) return;
    statusOrderSetsById[statusLabelId].add(id);
    statusOrderById[statusLabelId].push(id);
  };
  const addProfiles = clientProfiles => {
    clientProfiles.forEach(profile => {
      addProfile(profile);
      addProfileValueToStatus(profile.statusLabelId, profile.value);
    });
  };
  const getNormalizedStatuses = () => {
    const byId = _reduceInstanceProperty(statusIds).call(statusIds, (result, statusId) => {
      result[statusId] = _objectSpread(_objectSpread({}, statusesById[statusId]), {}, {
        order: [...(statusOrderById[statusId] || [])]
      });
      return result;
    }, {});
    return {
      byId,
      allIds: [...statusIds]
    };
  };
  return {
    addProfiles,
    addStatusMetadata,
    getNormalizedStatuses
  };
};
const createBoardClientPageCommitter = (context, boardId) => {
  const statusAccumulator = createBoardStatusAccumulator();
  return async ({
    clientProfiles,
    statistics,
    translationMap
  }, pageInfo) => {
    statistics.forEach(statusAccumulator.addStatusMetadata);
    const profileChunks = pageInfo.isFirstPage ? [clientProfiles] : splitIntoChunks(clientProfiles, CLIENT_PROFILE_RENDER_CHUNK_SIZE);
    for (let index = 0; index < profileChunks.length; index++) {
      const profileChunk = profileChunks[index];
      const replaceExistingBoardProfiles = pageInfo.isFirstPage && index === 0;
      statusAccumulator.addProfiles(profileChunk);
      context.commit(SET_BOARD_CLIENTS, {
        boardId,
        clientProfiles: normalizePageClientProfiles(profileChunk),
        replace: replaceExistingBoardProfiles
      });
      context.commit(SET_BOARD_STATUSES, {
        boardId,
        statistics: statusAccumulator.getNormalizedStatuses(),
        translationMap,
        replace: replaceExistingBoardProfiles
      });
      if (!pageInfo.isFirstPage) {
        await waitForUiWorkSlot();
      }
    }
  };
};
const actions = {
  [LOAD_BOARDS]: cacheAction(async (context, data = {}) => {
    try {
      const {
        agentUsername = ""
      } = data;
      const cacheKey = `boards_${agentUsername}`;
      const cachedData = getFromCache(cacheKey);
      if (cachedData) {
        const {
          sharedBoards,
          agentDetails
        } = cachedData;
        const {
          entities,
          result
        } = normalize(sharedBoards, [boardsSchema]);
        context.commit(SET_BOARDS, {
          byId: entities.boards || {},
          allIds: result
        });
        context.commit(SET_USER_DETAILS, agentDetails[0]);
        return;
      }
      const response = await getBoards({
        agentUsername
      });
      const {
        sharedBoards,
        agentDetails
      } = response;
      cacheWithExpiry(cacheKey, response);
      const {
        entities,
        result
      } = normalize(sharedBoards, [boardsSchema]);
      context.commit(SET_BOARDS, {
        byId: entities.boards || {},
        allIds: result
      });
      context.commit(SET_USER_DETAILS, agentDetails[0]);
    } catch (e) {
      Err.handle(e, {});
    }
  }, {
    timeout: 300000
  }),
  [LOAD_BOARD_COLLABORATORS]: cacheAction(async (context, {
    boardId
  }) => {
    try {
      const cacheKey = `board_collaborators_${boardId}`;
      const cachedData = getFromCache(cacheKey);
      if (cachedData) {
        const {
          entities,
          result
        } = normalize(cachedData, [collaboratorsSchema]);
        context.commit(SET_BOARD_COLLABORATORS, {
          boardId,
          byId: entities.collaborators || {},
          allIds: result
        });
        return;
      }
      const {
        boardCollaborators
      } = await getBoardCollaborators(boardId);
      cacheWithExpiry(cacheKey, boardCollaborators);
      const {
        entities,
        result
      } = normalize(boardCollaborators, [collaboratorsSchema]);
      context.commit(SET_BOARD_COLLABORATORS, {
        boardId,
        byId: entities.collaborators || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  }, {
    timeout: 300000
  }),
  [ORDER_BOARDS]: async (context, orderedBoards) => {
    const currentBoards = cloneDeep(context.state.boards);
    try {
      const order = _mapInstanceProperty(orderedBoards).call(orderedBoards, ({
        id: boardId,
        boardOrder
      }) => ({
        boardId,
        boardOrder
      }));
      const {
        entities,
        result
      } = normalize(orderedBoards, [boardsSchema]);
      context.commit(SET_BOARDS, {
        byId: entities.boards || {},
        allIds: result
      });
      await orderBoards({
        order
      });
      invalidateCache("boards_");
    } catch (e) {
      context.commit(SET_BOARDS, currentBoards);
      Err.handle(e, {});
    }
  },
  [LOAD_BOARD_CLIENTS]: async (context, {
    boardId
  }) => {
    try {
      const {
        remainingPagesPromise
      } = await getBoardClientProfilePages(boardId, createBoardClientPageCommitter(context, boardId));
      remainingPagesPromise.catch(e => {
        Err.handle(e, {});
      });
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [MOVE_BOARD_PROFILE]: async (context, {
    movedProfile = null,
    fromStatus,
    toStatus,
    toOrder
  }) => {
    const {
      selectedBoardId,
      boardsStatuses,
      boards
    } = context.state;
    const selectedBoard = boards.byId[selectedBoardId];
    const {
      sortBy
    } = selectedBoard;
    try {
      if (!movedProfile) return;
      const {
        statusLabelId,
        status
      } = movedProfile;
      if (fromStatus != toStatus) {
        var _context;
        const statuses = boardsStatuses[selectedBoardId].byId;
        const fromOrder = _filterInstanceProperty(_context = statuses[fromStatus].order).call(_context, o => o !== movedProfile.id);
        context.commit(SET_BOARD_CLIENT, {
          clientProfile: _objectSpread(_objectSpread({}, movedProfile), {}, {
            daysSinceLastActive: 0,
            statusLabelId,
            status
          })
        });
        context.commit(REMOVE_CHANGELOG_LAST_CHANGES, {
          clientProfileId: movedProfile.id
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: fromOrder,
          statusLabelId: fromStatus
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: toOrder,
          statusLabelId: toStatus
        });
        await updateProfileDetails(movedProfile.id, {
          status,
          statusLabelId
        });
        if (sortBy === "none") {
          await updateStatusOrder(selectedBoardId, {
            affectedColumns: [{
              statusLabelId: Number(fromStatus),
              order: _mapInstanceProperty(fromOrder).call(fromOrder, f => Number(f))
            }, {
              statusLabelId: Number(toStatus),
              order: _mapInstanceProperty(toOrder).call(toOrder, f => Number(f))
            }]
          });
        }
      } else {
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: toOrder,
          statusLabelId: toStatus
        });
        if (sortBy === "none") {
          await updateStatusOrder(selectedBoardId, {
            affectedColumns: [{
              statusLabelId: Number(toStatus),
              order: _mapInstanceProperty(toOrder).call(toOrder, f => Number(f))
            }]
          });
        }
      }
    } catch (e) {
      var _e$responseJSON$messa, _e$responseJSON;
      Err.handle(e, {}, (_e$responseJSON$messa = (_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.message) != null ? _e$responseJSON$messa : "somethingWentWrongTryAgainLater");
    }
  },
  [LOAD_DEFAULT_BOARD_ID]: async context => {
    try {
      var _currentDefaultBoardI;
      const {
        boards,
        defaultBoardId
      } = context.state;
      let currentDefaultBoardId = defaultBoardId;
      const localDefaultBoardExists = !isEmpty(boards.byId[defaultBoardId]);
      if (!currentDefaultBoardId || !localDefaultBoardExists) {
        const defaultBoard = find(boards.byId, board => board.default && board.owner);
        if (defaultBoard) {
          currentDefaultBoardId = defaultBoard.id;
        }
      }
      context.commit(SET_DEFAULT_BOARD_ID, {
        defaultBoardId: ((_currentDefaultBoardI = currentDefaultBoardId) == null ? void 0 : _currentDefaultBoardI.toString()) || ""
      });
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [UPDATE_DEFAULT_BOARD]: async (context, {
    boardId
  }) => {
    const currentDefaultBoard = context.state.defaultBoardId;
    try {
      context.commit(SET_DEFAULT_BOARD_ID, {
        defaultBoardId: boardId.toString()
      });
      await setBoardAsDefault(boardId);
    } catch (e) {
      context.commit(SET_DEFAULT_BOARD_ID, {
        defaultBoardId: currentDefaultBoard
      });
      Err.handle(e, {});
      throw e;
    }
  },
  [UPDATE_BOARD_CLIENTS]: (context, {
    currentBoard,
    boardId
  }) => {
    context.commit(INCREMENT_BOARD_CLIENTS, {
      boardId
    });
    context.commit(DECREMENT_BOARD_CLIENTS, {
      boardId: currentBoard
    });
  },
  [CREATE_STATE_COLUMN]: async (context, {
    label,
    muteNotifications,
    muteAutomations,
    rottingDaysThreshold
  }) => {
    const {
      selectedBoardId,
      boardsStatuses
    } = context.state;
    try {
      const statuses = boardsStatuses[selectedBoardId].byId;
      const isDuplicated = !isEmpty(find(statuses, value => value.label === label));
      if (isDuplicated) throw new Error("ColumnExists");
      const {
        clientStatusLabelId: id
      } = await createBoardStatus(selectedBoardId, {
        label,
        muteNotifications,
        muteAutomations,
        rottingDaysThreshold
      });
      const status = {
        id,
        label,
        muteNotifications,
        muteAutomations,
        rottingDaysThreshold,
        count: 0,
        value: 0,
        hasEmailAutomation: false
      };
      context.commit(ADD_BOARD_STATUS, {
        boardId: selectedBoardId,
        status
      });
    } catch (e) {
      const message = e.message === "ColumnExists" ? "Status Already Exists" : "";
      Err.handle(e, {}, message);
      throw e;
    }
  },
  [UPDATE_STATE_COLUMN_CONFIG]: async (context, {
    rottingDaysThreshold,
    muteAutomations,
    muteNotifications,
    statusLabelId
  }) => {
    const {
      selectedBoardId
    } = context.state;
    try {
      context.commit(SET_BOARD_STATUS, {
        boardId: selectedBoardId,
        status: {
          id: statusLabelId,
          muteNotifications,
          muteAutomations,
          rottingDaysThreshold
        }
      });
      await updateBoardStatus(selectedBoardId, statusLabelId, {
        muteNotifications,
        muteAutomations,
        rottingDaysThreshold
      });
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  },
  [MOVE_STATUS_COLUMN]: async (context, {
    statusLabelId,
    dir
  }) => {
    const {
      selectedBoardId,
      boards
    } = context.state;
    const {
      order
    } = boards.byId[selectedBoardId];
    try {
      const labelIndex = _indexOfInstanceProperty(order).call(order, statusLabelId);
      const targetIndex = labelIndex + dir;
      if (targetIndex >= 0 && targetIndex < order.length) {
        const newOrder = cloneDeep(order);
        const aux = newOrder[targetIndex];
        newOrder[targetIndex] = newOrder[labelIndex];
        newOrder[labelIndex] = aux;
        context.commit(SET_BOARD_ORDER, {
          boardId: selectedBoardId,
          order: newOrder
        });
        await updateBoard(selectedBoardId, {
          order: {
            statusLabelId: _parseInt(statusLabelId),
            index: targetIndex
          }
        });
      }
    } catch (e) {
      context.commit(SET_BOARD_ORDER, {
        boardId: selectedBoardId,
        order
      });
      Err.handle(e);
    }
  },
  [DELETE_STATUS_COLUMN]: async (context, {
    statusLabelId,
    defaultColumn
  }) => {
    const {
      selectedBoardId,
      boardsStatuses
    } = context.state;
    const currentStatus = boardsStatuses[selectedBoardId].byId[statusLabelId];
    const movedClientProfiles = currentStatus.order || [];
    context.commit(MOVE_PROFILES_TO_COLUMN, {
      boardId: selectedBoardId,
      statusLabelId: defaultColumn.id,
      profiles: movedClientProfiles
    });
    context.commit(REMOVE_BOARD_STATUS, {
      boardId: selectedBoardId,
      statusLabelId
    });
    try {
      await deleteBoardStatus(selectedBoardId, statusLabelId);
    } catch (e) {
      context.commit(ADD_BOARD_STATUS, {
        boardId: selectedBoardId,
        status: currentStatus
      });
      context.commit(MOVE_PROFILES_TO_COLUMN, {
        boardId: selectedBoardId,
        statusLabelId,
        profiles: movedClientProfiles
      });
      Err.handle(e);
    }
  },
  [UPDATE_STATE_COLUMN_LABEL]: async (context, {
    label,
    statusLabelId
  }) => {
    const {
      selectedBoardId
    } = context.state;
    try {
      context.commit(SET_BOARD_STATUS, {
        boardId: selectedBoardId,
        status: {
          id: statusLabelId,
          label
        }
      });
      await updateBoardStatus(selectedBoardId, statusLabelId, {
        label
      });
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  },
  [CREATE_CLIENT_BOARD]: async (context, {
    boardName
  }) => {
    try {
      const {
        boardId,
        labelOrder
      } = await createBoard({
        boardName
      });
      const agentDetails = {
        username: context.state.agentUsername.username,
        familyName: context.state.agentUsername.familyName,
        givenName: context.state.agentUsername.givenName,
        photoVersion: context.state.agentUsername.photoVersion,
        profilePhoto: context.state.agentUsername.profilePhoto
      };
      const boarderOrder = context.state.boards.allIds.length + 1;
      const newBoard = {
        agentUsername: context.state.agentUsername.username,
        boarderOrder,
        boardProfiles: Array[0],
        clientBoardFilter: {},
        default: false,
        id: boardId,
        name: boardName,
        noActivityFirst: false,
        numberOfClients: "0",
        order: labelOrder,
        owner: true,
        ownerDetails: agentDetails,
        sortBy: "none",
        sortByOrder: "asc",
        trackEmails: false
      };
      context.commit(ADD_BOARD, newBoard);
      invalidateCache("boards_");
      return boardId;
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  },
  [DUPLICATE_CLIENT_BOARD]: async (context, {
    boardName,
    oldBoardId
  }) => {
    try {
      const {
        boardId,
        labelOrder
      } = await duplicateBoard({
        boardName,
        boardId: oldBoardId
      });
      const oldBoard = cloneDeep(context.state.boards.byId[oldBoardId]);
      oldBoard.boardOrder = (context.state.boards.allIds.length + 1).toString();
      oldBoard.boardProfiles = [];
      oldBoard.name = boardName;
      oldBoard.id = boardId;
      oldBoard.order = labelOrder;
      oldBoard.default = false;
      oldBoard.numberOfClients = "0";
      context.commit(ADD_BOARD, oldBoard);
      invalidateCache("boards_");
      return boardId;
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  },
  [UPDATE_CLIENT_BOARD]: async (context, {
    boardName,
    boardId
  }) => {
    const oldBoardName = context.state.boards.byId[boardId].name;
    try {
      context.commit(SET_BOARD, {
        id: boardId,
        name: boardName
      });
      await updateBoard(boardId, {
        boardName
      });
    } catch (e) {
      context.commit(SET_BOARD, {
        id: boardId,
        name: oldBoardName
      });
      Err.handle(e, {});
      throw e;
    }
  },
  [UPDATE_CLIENT_BOARD_VISIBILITY]: async (context, {
    boardId,
    visibility
  }) => {
    const oldBoardVisibility = context.state.boards.byId[boardId].visibility;
    try {
      context.commit(SET_BOARD, {
        id: boardId,
        visibility
      });
      await updateBoard(boardId, {
        visibility
      });
    } catch (e) {
      context.commit(SET_BOARD, {
        id: boardId,
        visibility: oldBoardVisibility
      });
      Err.handle(e, {});
      throw e;
    }
  },
  [DELETE_CLIENT_BOARD]: async (context, {
    boardId
  }) => {
    try {
      await deleteBoard(boardId);
      context.commit(REMOVE_CLIENT_BOARD, {
        boardId
      });
      invalidateCache("boards_");
      invalidateCache(`custom_fields_${boardId}`);
      invalidateCache(`board_collaborators_${boardId}`);
    } catch (e) {
      Err.handle(e, {});
      throw e;
    }
  },
  [UPDATE_COLLABORATOR_SETTINGS]: async (context, {
    boardId,
    username,
    trackEmails,
    visibility,
    collaboratorId = 0
  }) => {
    const currentDetails = context.state.collaborators[boardId].byId[username];
    try {
      if (collaboratorId === 0) {
        context.commit(SET_TRACK_EMAILS, {
          boardId,
          trackEmails
        });
      } else {
        context.commit(SET_COLLABORATOR_DETAILS, {
          username,
          boardId,
          trackEmails,
          visibility
        });
      }
      await updateCollaboratorSettings(boardId, collaboratorId, {
        trackEmails,
        visibility
      });
    } catch (e) {
      if (collaboratorId === 0) {
        context.commit(SET_TRACK_EMAILS, {
          boardId,
          trackEmails: currentDetails.trackEmails
        });
      } else {
        context.commit(SET_COLLABORATOR_DETAILS, {
          boardId,
          trackEmails: currentDetails.trackEmails,
          visibility: currentDetails.visibility
        });
      }
      Err.handle(e, {});
    }
  },
  [DOWNLOAD_CSV_EXPORT]: async () => {
    try {
      showToast("success", "downloadingFile");
      const {
        url
      } = await downloadDocument();
      openFileDialog(url, "report.csv");
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_CLIENT_PROFILE_COLOR]: async (context, {
    clientProfileId,
    cardColour
  }) => {
    const {
      clientProfiles
    } = context.state;
    const currentColor = clientProfiles.byId[clientProfileId].cardColour;
    try {
      context.commit(SET_CLIENT_PROFILE_CARD_COLOR, {
        clientProfileId,
        cardColour
      });
      await updateProfileDetails(clientProfileId, {
        cardColour
      });
    } catch (e) {
      context.commit(SET_CLIENT_PROFILE_CARD_COLOR, {
        clientProfileId,
        cardColour: currentColor
      });
      Err.handle(e);
    }
  },
  [MARK_CLIENT_PROFILE_INACTIVE]: async (context, {
    clientProfileId
  }) => {
    const {
      selectedBoardId
    } = context.state;
    try {
      await updateProfileDetails(clientProfileId, {
        active: false
      });
      context.commit(REMOVE_PROFILE_FROM_ORDER, {
        boardId: selectedBoardId,
        clientProfileId
      });
      context.commit(SET_PROFILE_ACTIVE, {
        id: clientProfileId,
        active: false
      });
      context.commit(DECREMENT_BOARD_CLIENTS, {
        boardId: selectedBoardId
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [CREATE_PROFILE_QUICK_NOTE]: async (context, {
    clientProfileId,
    note
  }) => {
    const {
      clientProfiles
    } = context.state;
    try {
      await addNote(clientProfileId, note);
      context.commit(SET_BOARD_CLIENT, {
        clientProfile: _objectSpread(_objectSpread({}, clientProfiles.byId[clientProfileId]), {}, {
          daysSinceLastActive: 0
        })
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [CREATE_QUICK_REMINDER]: async (context, {
    clientProfileId,
    reminder
  }) => {
    try {
      await addFollowUp(clientProfileId, reminder);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [CREATE_PROFILE_QUICK_REMINDER]: async (context, {
    clientProfileId,
    reminder
  }) => {
    const {
      clientProfiles
    } = context.state;
    const {
      reminders: currentReminders,
      daysSinceLastActive
    } = clientProfiles.byId[clientProfileId];
    try {
      const {
        followUpId
      } = await addFollowUp(clientProfileId, reminder);
      context.commit(ADD_BOARD_CLIENT_REMINDERS, {
        clientProfileId,
        reminders: [_objectSpread(_objectSpread({}, reminder), {}, {
          id: _parseInt(followUpId)
        })]
      });
      context.commit(SET_BOARD_CLIENT, {
        clientProfile: _objectSpread(_objectSpread({}, clientProfiles.byId[clientProfileId]), {}, {
          daysSinceLastActive: 0
        })
      });
    } catch (e) {
      context.commit(SET_BOARD_CLIENT_REMINDERS, {
        clientProfileId,
        reminders: currentReminders
      });
      context.commit(SET_BOARD_CLIENT, {
        clientProfile: _objectSpread(_objectSpread({}, clientProfiles.byId[clientProfileId]), {}, {
          daysSinceLastActive
        })
      });
      Err.handle(e);
      throw e;
    }
  },
  [TRANSFER_BOARD_CLIENT_PROFILE]: async (context, {
    clientProfileId,
    statusLabelId,
    boardId
  }) => {
    const {
      selectedBoardId
    } = context.state;
    try {
      await transferClientProfile(boardId, clientProfileId, statusLabelId);
      context.commit(REMOVE_CLIENT_PROFILE, {
        boardId: selectedBoardId,
        clientProfileId
      });
      context.commit(DECREMENT_BOARD_CLIENTS, {
        boardId: selectedBoardId
      });
      context.commit(INCREMENT_BOARD_CLIENTS, {
        boardId
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [ASSIGN_BOARD_COLLABORATOR]: async (context, {
    boardId,
    collaborator
  }) => {
    const {
      familyName,
      givenName,
      photoVersion,
      profilePhoto,
      username
    } = collaborator;
    const {
      name: boardName
    } = context.state.boards.byId[boardId];
    try {
      const {
        collaborationId
      } = await addBoardCollaborator(boardId, username);
      context.commit(SET_BOARD_COLLABORATOR, {
        boardId,
        collaborator: {
          boardId,
          collaborationId,
          boardName,
          familyName,
          givenName,
          photoVersion,
          profilePhoto,
          username,
          trackEmails: false,
          visibility: "all"
        }
      });
    } catch (e) {
      context.commit(REMOVE_BOARD_COLLABORATOR, {
        boardId,
        collaboratorUsername: username
      });
      Err.handle(e);
    }
  },
  [UNASSIGN_BOARD_COLLABORATOR]: async (context, {
    boardId,
    collaborator: {
      username,
      collaborationId
    }
  }) => {
    const currentCollaborator = context.state.collaborators[boardId].byId[username];
    try {
      context.commit(REMOVE_BOARD_COLLABORATOR, {
        boardId,
        collaboratorUsername: username
      });
      if (collaborationId) {
        await removeBoardCollaborator(boardId, collaborationId);
      }
    } catch (e) {
      context.commit(SET_BOARD_COLLABORATOR, {
        boardId,
        collaborator: currentCollaborator
      });
      Err.handle(e);
    }
  },
  [REMOVE_SELF_FROM_BOARD]: async (context, {
    username,
    boardId,
    collaborationId
  }) => {
    const currentCollaborator = context.state.collaborators[boardId].byId[username];
    try {
      if (collaborationId) {
        await removeSelfFromBoard(boardId, collaborationId);
      }
      context.commit(CHANGE_BOARD_TO_DEFAULT);
      context.commit(REMOVE_BOARD_COLLABORATOR, {
        boardId,
        collaboratorUsername: username
      });
      context.commit(REMOVE_CLIENT_BOARD, {
        boardId
      });
    } catch (e) {
      context.commit(SET_BOARD_COLLABORATOR, {
        boardId,
        collaborator: currentCollaborator
      });
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_CLIENT_PROFILE_REMINDER]: async (context, {
    reminder,
    clientProfileId
  }) => {
    try {
      context.commit(EDIT_CLIENT_PROFILE_REMINDER, {
        clientProfileId,
        reminder
      });
      await updateFollowUp(clientProfileId, reminder.id, reminder);
    } catch (e) {
      context.commit(EDIT_CLIENT_PROFILE_REMINDER, {
        clientProfileId,
        reminder: _objectSpread(_objectSpread({}, reminder), {}, {
          complete: !reminder.complete
        })
      });
      Err.handle(e, {});
    }
  },
  [CLEAR_COMPLETE_CLIENT_PROFILE_REMINDERS]: async (context, {
    clientProfileId
  }) => {
    try {
      context.commit(REMOVE_COMPLETE_CLIENT_PROFILE_REMINDERS, {
        clientProfileId
      });
    } catch (e) {
      Amplitude.logHandledError(e, {});
    }
  },
  [UPDATE_BOARD_SORT]: async (context, {
    boardId,
    sortBy,
    noActivityFirst,
    sortByOrder
  }) => {
    const {
      sortBy: oldSortBy,
      noActivityFirst: oldNoActivityFirst,
      sortByOrder: oldSortByOrder
    } = context.state.boards.byId[boardId];
    try {
      context.commit(SET_ACTIVITY_SORT, {
        boardId,
        sortBy,
        noActivityFirst,
        sortByOrder
      });
      await setBoardSortBy(boardId, sortBy, noActivityFirst, sortByOrder);
    } catch (e) {
      context.commit(SET_ACTIVITY_SORT, {
        boardId,
        sortBy: oldSortBy,
        noActivityFirst: oldNoActivityFirst,
        sortByOrder: oldSortByOrder
      });
      Err.handle(e);
    }
  },
  [RESET_CURRENT_SEARCH]: async context => {
    context.commit(SET_ACTIVE_SEARCH_STRING, {
      clientProfileSearchString: ""
    });
  },
  [CREATE_CLIENT_PROFILE]: async (context, {
    data,
    boardId
  }) => {
    try {
      const {
        clientProfileId
      } = await createNewProfile(data, boardId);
      Amplitude.logEvent("Board - client created");
      return clientProfileId;
    } catch (e) {
      Err.handle(e);
    }
  },
  [GET_CLIENT_DUPLICATE]: async (context, data) => {
    try {
      return await getDuplicateClients(data);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CUSTOM_FIELDS_DEFINITIONS]: cacheAction(async (context, {
    boardId
  }) => {
    try {
      const cacheKey = `custom_fields_${boardId}`;
      const cachedData = getFromCache(cacheKey);
      if (cachedData) {
        const {
          customProfileFields,
          translationMap
        } = cachedData;
        const {
          entities,
          result
        } = normalize(customProfileFields, [customFieldsSchema]);
        const boardsCustomFieldsDefinitions = {
          byId: entities.customFields,
          allIds: result
        };
        boardsCustomFieldsDefinitions.allIds = sortBy(boardsCustomFieldsDefinitions.allIds, id => {
          var _boardsCustomFieldsDe;
          const {
            name,
            classification
          } = ((_boardsCustomFieldsDe = boardsCustomFieldsDefinitions.byId) == null ? void 0 : _boardsCustomFieldsDe[id]) || {};
          const weightMap = {
            "Upcoming Date": 1,
            "Closing Date": 2,
            "Renewal Date": 3,
            Label: 4
          };
          return classification === "system" && weightMap[name || ""] || Infinity;
        });
        context.commit(SET_CUSTOM_FIELDS_DEFINITIONS, {
          boardId,
          boardsCustomFieldsDefinitions
        });
        context.commit(SET_CUSTOM_FIELD_TRANSLATION_MAP, {
          boardId,
          translationMap
        });
        return;
      }
      const response = await getCustomFieldsDeclarations(boardId);
      cacheWithExpiry(cacheKey, response);
      const {
        customProfileFields,
        translationMap
      } = response;
      const {
        entities,
        result
      } = normalize(customProfileFields, [customFieldsSchema]);
      const boardsCustomFieldsDefinitions = {
        byId: entities.customFields,
        allIds: result
      };
      boardsCustomFieldsDefinitions.allIds = sortBy(boardsCustomFieldsDefinitions.allIds, id => {
        var _boardsCustomFieldsDe2;
        const {
          name,
          classification
        } = ((_boardsCustomFieldsDe2 = boardsCustomFieldsDefinitions.byId) == null ? void 0 : _boardsCustomFieldsDe2[id]) || {};
        const weightMap = {
          "Upcoming Date": 1,
          "Closing Date": 2,
          "Renewal Date": 3,
          Label: 4
        };
        return classification === "system" && weightMap[name || ""] || Infinity;
      });
      context.commit(SET_CUSTOM_FIELDS_DEFINITIONS, {
        boardId,
        boardsCustomFieldsDefinitions
      });
      context.commit(SET_CUSTOM_FIELD_TRANSLATION_MAP, {
        boardId,
        translationMap
      });
    } catch (e) {
      Err.handle(e);
    }
  }, {
    timeout: 300000
  }),
  [GET_CLIENT_PROFILE_PARTICIPANTS]: async (context, {
    clientProfileId
  }) => {
    try {
      var _context$rootState$Se, _context$rootState$Se2;
      const username = ((_context$rootState$Se = context.rootState.SettingsStore) == null ? void 0 : (_context$rootState$Se2 = _context$rootState$Se.user) == null ? void 0 : _context$rootState$Se2.username) || "";
      const participants = await getParticipants(username, clientProfileId);
      return participants;
    } catch (e) {
      Err.handle(e, {
        clientProfileId
      }, "failedToLoadParticipants");
      throw e;
    }
  },
  [ADD_CLIENT_PROFILE_PARTICIPANTS]: async (context, {
    clientProfileId,
    participantData
  }) => {
    try {
      var _context$rootState$Se3, _context$rootState$Se4;
      const username = ((_context$rootState$Se3 = context.rootState.SettingsStore) == null ? void 0 : (_context$rootState$Se4 = _context$rootState$Se3.user) == null ? void 0 : _context$rootState$Se4.username) || "";
      const result = await addParticipant(username, clientProfileId, participantData);
      context.commit(SET_PROFILE_PARTICIPANTS, {
        clientProfileId,
        participants: result
      });
      return result;
    } catch (e) {
      Err.handle(e, {
        clientProfileId,
        participantData
      }, "failedToAddParticipant");
      throw e;
    }
  },
  [UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT]: async (context, {
    clientProfileId,
    participantId,
    participantData
  }) => {
    try {
      var _context$rootState$Se5, _context$rootState$Se6;
      const username = ((_context$rootState$Se5 = context.rootState.SettingsStore) == null ? void 0 : (_context$rootState$Se6 = _context$rootState$Se5.user) == null ? void 0 : _context$rootState$Se6.username) || "";
      const result = await updateParticipant(username, clientProfileId, participantId, participantData);
      context.commit(SET_PROFILE_PARTICIPANTS, {
        clientProfileId,
        participants: result
      });
      return result;
    } catch (e) {
      Err.handle(e, {
        clientProfileId,
        participantId,
        participantData
      }, "failedToUpdateParticipant");
      throw e;
    }
  },
  [UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER]: async (context, {
    clientProfileId,
    participantOrder
  }) => {
    try {
      var _context$rootState$Se7, _context$rootState$Se8;
      const username = ((_context$rootState$Se7 = context.rootState.SettingsStore) == null ? void 0 : (_context$rootState$Se8 = _context$rootState$Se7.user) == null ? void 0 : _context$rootState$Se8.username) || "";
      const result = await updateParticipantOrder(username, clientProfileId, participantOrder);
      context.commit(SET_PROFILE_PARTICIPANTS, {
        clientProfileId,
        participants: result
      });
      return result;
    } catch (e) {
      Err.handle(e, {
        clientProfileId,
        participantOrder
      }, "failedToUpdateParticipantOrder");
      throw e;
    }
  },
  [DELETE_CLIENT_PROFILE_PARTICIPANTS]: async (context, {
    clientProfileId,
    participantId
  }) => {
    try {
      var _context$rootState$Se9, _context$rootState$Se0;
      const username = ((_context$rootState$Se9 = context.rootState.SettingsStore) == null ? void 0 : (_context$rootState$Se0 = _context$rootState$Se9.user) == null ? void 0 : _context$rootState$Se0.username) || "";
      const result = await deleteParticipant(username, clientProfileId, participantId);
      context.commit(SET_PROFILE_PARTICIPANTS, {
        clientProfileId,
        participants: result
      });
      return result;
    } catch (e) {
      Err.handle(e, {
        clientProfileId,
        participantId
      }, "failedToDeleteParticipant");
      throw e;
    }
  },
  [CREATE_CUSTOM_FIELD_DEFINITION]: async (context, {
    boardId,
    customFieldDefinition
  }) => {
    try {
      const {
        customFieldId,
        fieldOrder
      } = await createCustomFieldDeclaration(boardId, customFieldDefinition);
      context.commit(ADD_CUSTOM_FIELD_DEFINITION, {
        boardId,
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          classification: "user",
          id: customFieldId,
          fieldOrder
        })
      });
      invalidateCache(`custom_fields_${boardId}`);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_CUSTOM_FIELD_DEFINITION]: async (context, {
    boardId,
    customFieldDefinition
  }) => {
    try {
      await updateCustomFieldDeclaration(boardId, customFieldDefinition);
      context.commit(SET_CUSTOM_FIELD_DEFINITION, {
        boardId,
        customFieldDefinition
      });
      invalidateCache(`custom_fields_${boardId}`);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [ORDER_CUSTOM_FIELD_DEFINITION]: async (context, {
    boardId,
    customFieldDefinitions
  }) => {
    const oldCustomFieldsDefinitions = cloneDeep(values(context.state.boardsCustomFieldsDefinitions[boardId].byId));
    try {
      const updatedCustomFieldDefinitions = map(customFieldDefinitions, ({
        id
      }, index) => ({
        id,
        fieldOrder: index + 1
      }));
      context.commit(SET_CUSTOM_FIELD_ORDER, {
        boardId,
        customFieldDefinitions: updatedCustomFieldDefinitions
      });
      await updateCustomFieldOrder(boardId, {
        order: updatedCustomFieldDefinitions
      });
    } catch (e) {
      context.commit(SET_CUSTOM_FIELDS_DEFINITIONS, {
        boardId,
        boardsCustomFieldsDefinitions: oldCustomFieldsDefinitions
      });
      Err.handle(e);
    }
  },
  [TOGGLE_CUSTOM_FIELD_DEFINITION_VISIBILITY]: async (context, {
    boardId,
    customFieldDefinitionId
  }) => {
    const customFieldDefinition = context.state.boardsCustomFieldsDefinitions[boardId].byId[customFieldDefinitionId];
    const oldVisibility = customFieldDefinition.visibility;
    try {
      const newVisibility = getArrayNextItem(oldVisibility, ["none", "full", "compact"]);
      context.commit(SET_CUSTOM_FIELD_DEFINITION, {
        boardId,
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          visibility: newVisibility
        })
      });
      await updateCustomFieldDeclaration(boardId, _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
        visibility: newVisibility
      }));
    } catch (e) {
      context.commit(SET_CUSTOM_FIELD_DEFINITION, {
        boardId,
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          visibility: oldVisibility
        })
      });
      Err.handle(e);
    }
  },
  [DELETE_CUSTOM_FIELD_DEFINITION]: async (context, {
    boardId,
    customFieldDefinitionId
  }) => {
    try {
      await deleteCustomFieldDeclaration(boardId, customFieldDefinitionId);
      context.commit(REMOVE_CUSTOM_FIELD_DEFINITION, {
        boardId,
        customFieldDefinitionId
      });
      invalidateCache(`custom_fields_${boardId}`);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_BOARD_PROFILE]: async (context, {
    clientProfileId,
    details
  }) => {
    if (isEmpty(context.state.clientProfiles.byId)) return;
    context.commit(SET_BOARD_PROFILE, {
      clientProfileId,
      details
    });
  },
  [UPDATE_BOARD_FILTERS]: async (context, {
    boardId,
    clientBoardFilter,
    collaboratorId
  }) => {
    const {
      clientBoardFilter: oldClientBoardFilter
    } = context.state.boards.byId[boardId];
    try {
      context.commit(SET_BOARD_FILTER, {
        boardId,
        clientBoardFilter
      });
      if (collaboratorId) {
        await updateCollaboratorSettings(boardId, collaboratorId, {
          clientBoardFilter
        });
      } else {
        await updateBoard(boardId, {
          clientBoardFilter
        });
      }
    } catch (e) {
      context.commit(SET_BOARD_FILTER, {
        boardId,
        clientBoardFilter: oldClientBoardFilter
      });
      Err.handle(e, {});
    }
  },
  [CACHED_CLIENT_PROFILE_DATA]: cacheAction(async (context, {
    clientProfileId
  }) => {
    await _Promise.all([context.dispatch("LOAD_CLIENT_PROFILE_DETAILS", {
      clientProfileId
    }), context.dispatch("LOAD_EMAIL_TEMPLATES")]);
  }, {
    timeout: 30000
  }),
  [LOAD_CLIENT_PROFILE_DETAILS]: async (context, {
    clientProfileId: id
  }) => {
    try {
      const [profileData, profileCollaboratorsData] = await _Promise.all([getProfileDetails(id), getProfileCollaborators(id)]);
      const {
        clientProfile: details,
        statusLabels
      } = profileData;
      const {
        profileCollaborators
      } = profileCollaboratorsData;
      DEPRECATED_CLIENT_PROFILE_DETAILS.forEach(key => delete details[key]);
      context.commit(SET_CLIENT_PROFILE, {
        id,
        value: _objectSpread(_objectSpread({}, details), {}, {
          value: details.value || "0.00",
          coApplicants: details.coApplicants.length ? details.coApplicants : cloneDeep(defaultState().coApplicants)
        }),
        statusLabels
      });
      const collaborators = _mapInstanceProperty(profileCollaborators).call(profileCollaborators, _ref => {
        let {
            collaborator
          } = _ref,
          item = _objectWithoutProperties(_ref, _excluded);
        return _objectSpread(_objectSpread({}, item), {}, {
          username: collaborator
        });
      });
      const {
        entities,
        result
      } = normalize(collaborators, [collaboratorsSchema]);
      context.commit(SET_PROFILE_COLLABORATORS, {
        id,
        byId: entities.collaborators || {},
        allIds: result
      });
    } catch (e) {
      var _e$responseJSON2;
      if (((_e$responseJSON2 = e.responseJSON) == null ? void 0 : _e$responseJSON2.code) === "NotAuthorizedException") {
        Err.handle(e, {}, e.responseJSON.message);
        window.location.href = "#/board";
        return;
      }
      Err.handle(e);
    }
  },
  [LOAD_CLIENT_PROFILE_SUBSCRIBERS]: async (context, {
    clientProfileId
  }) => {
    try {
      const {
        subscribers
      } = await getNotifiedReferrers(clientProfileId);
      const {
        entities,
        result
      } = normalize(subscribers, [subscribersSchema]);
      context.commit(SET_PROFILE_NOTIFIED_REFERRERS, {
        clientProfileId,
        notifiedReferrers: {
          byId: entities.subscribers || {},
          allIds: result
        }
      });
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [LOAD_PROFILE_COLLABORATORS]: async (context, {
    id
  }) => {
    const {
      profileCollaborators
    } = await getProfileCollaborators(id);
    const collaborators = _mapInstanceProperty(profileCollaborators).call(profileCollaborators, _ref2 => {
      let {
          collaborator
        } = _ref2,
        item = _objectWithoutProperties(_ref2, _excluded2);
      return _objectSpread(_objectSpread({}, item), {}, {
        username: collaborator
      });
    });
    const {
      entities,
      result
    } = normalize(collaborators, [collaboratorsSchema]);
    context.commit(SET_PROFILE_COLLABORATORS, {
      id,
      byId: entities.collaborators || {},
      allIds: result
    });
  },
  [ADD_PROFILE_COLLABORATOR]: async (context, {
    id,
    collaborator
  }) => {
    context.commit(UPDATE_PROFILE_COLLABORATORS, {
      id,
      action: "add",
      collaborator
    });
    try {
      const {
        collaborationId,
        trackEmails
      } = await addClientProfileCollaborator(id, collaborator.username);
      context.commit(UPDATE_PROFILE_COLLABORATOR_DETAILS, {
        id,
        username: collaborator.username,
        key: "trackEmails",
        value: trackEmails
      });
      context.commit(UPDATE_PROFILE_COLLABORATOR_DETAILS, {
        id,
        username: collaborator.username,
        key: "collaborationId",
        value: collaborationId
      });
    } catch (e) {
      context.commit(UPDATE_PROFILE_COLLABORATORS, {
        id,
        action: "remove",
        collaborator
      });
      Err.handle(e, {
        id,
        collaborator
      }, "failedToAddCollaborator");
    }
  },
  [REMOVE_PROFILE_COLLABORATOR]: async (context, {
    id,
    collaborator
  }) => {
    context.commit(UPDATE_PROFILE_COLLABORATORS, {
      id,
      action: "remove",
      collaborator
    });
    try {
      if (collaborator.collaborationId) {
        await removeProfileCollaborator(id, collaborator.collaborationId);
      }
    } catch (e) {
      context.commit(UPDATE_PROFILE_COLLABORATORS, {
        id,
        action: "add",
        collaborator
      });
      Err.handle(e, {
        id,
        collaborator
      }, "failedToRemovecollaborator");
    }
  },
  [TOGGLE_COLLABORATOR_EMAIL_SYNC]: async (context, {
    id,
    username,
    collaborationId,
    isCurrentUser,
    enabled
  }) => {
    const isEnabled = isCurrentUser ? enabled : context.state.clientProfiles.byId[id].collaborators.byId[username].trackEmails;
    try {
      if (isCurrentUser) {
        context.commit(SET_EMAIL_TACKING, {
          id,
          trackEmails: !enabled
        });
      } else {
        context.commit(UPDATE_PROFILE_COLLABORATOR_DETAILS, {
          id,
          username,
          key: "trackEmails",
          value: !isEnabled
        });
      }
      await updateCollaboratorEmailSync(id, collaborationId, !isEnabled);
    } catch (e) {
      if (isCurrentUser) {
        context.commit(SET_EMAIL_TACKING, {
          id,
          trackEmails: enabled
        });
      } else {
        context.commit(UPDATE_PROFILE_COLLABORATOR_DETAILS, {
          id,
          username,
          key: "trackEmails",
          value: isEnabled
        });
      }
      Err.handle(e, {
        id,
        username,
        trackEmails: isEnabled,
        collaborationId
      }, "Failed to update email tracking for collaborator");
    }
  },
  [SET_CLIENT_PROFILE_ACTIVE_STATUS]: async (context, {
    id,
    status
  }) => {
    await updateProfileDetails(id, {
      active: status
    });
    context.commit(SET_PROFILE_ACTIVE, {
      id,
      active: status
    });
  },
  [CHANGE_PROFILE_OWNER]: async (context, {
    id,
    owner,
    clientUsername
  }) => {
    if (clientUsername) {
      context.commit("ApplicationStore/SET_CLIENT_OWNER", {
        clientUsername,
        agentUsername: owner.username
      }, {
        root: true
      });
    }
    context.commit(UPDATE_PROFILE_OWNER, {
      id,
      owner
    });
    context.commit(SET_EMAIL_TACKING, {
      id,
      trackEmails: false
    });
    await changeOwner(id, owner.username);
  },
  [TRANSFER_CLIENT_PROFILE]: async (context, {
    id,
    statusLabelId,
    boardId,
    inactive
  }) => {
    try {
      await transferClientProfile(boardId, id, statusLabelId);
      if (!inactive) {
        await Vue.router.replace({
          name: "client-profile",
          params: {
            boardId,
            clientProfileId: id,
            ignoreStateChange: true,
            moved: true
          }
        });
        await context.dispatch("LOAD_CLIENT_PROFILE_DETAILS", {
          clientProfileId: id
        });
      }
    } catch (e) {
      var _e$responseJSON$messa2, _e$responseJSON3;
      const message = (_e$responseJSON$messa2 = (_e$responseJSON3 = e.responseJSON) == null ? void 0 : _e$responseJSON3.message) != null ? _e$responseJSON$messa2 : "Unexpected error when transferring profile";
      Err.handle(e, {
        clientProfileId: id,
        statusLabelId,
        boardId,
        name: TRANSFER_CLIENT_PROFILE
      }, message);
      throw e;
    }
  },
  [LINK_CLIENT_PROFILE]: async (context, {
    clientProfileId,
    accountUsername
  }) => {
    try {
      const {
        referrerId
      } = await linkApplication(clientProfileId, accountUsername);
      await context.dispatch(LOAD_CHANGELOG, {
        clientProfileId
      });
      context.commit(SET_LINKED_USERNAME, {
        id: clientProfileId,
        accountUsername
      });
      Amplitude.updateCount("linked applications");
      Amplitude.logEvent("Board - application linked", {
        page: "clients-board",
        clientProfileId,
        clientUsername: accountUsername
      });
      return referrerId;
    } catch (e) {
      Err.handle(e, {
        clientProfileId,
        accountUsername
      });
    }
  },
  [UNLINK_CLIENT_PROFILE]: async (context, {
    clientProfileId
  }) => {
    try {
      await linkApplication(clientProfileId, null);
      await context.dispatch(LOAD_CHANGELOG, {
        clientProfileId
      });
      context.commit(SET_LINKED_USERNAME, {
        id: clientProfileId,
        accountUsername: null
      });
      Amplitude.updateCount("unlinked applications");
      Amplitude.logEvent("Board - application unlinked", {
        page: "clients-board",
        clientProfileId
      });
    } catch (e) {
      Err.handle(e, {
        clientProfileId
      });
    }
  },
  [ASSIGN_REFERRER]: async (context, {
    referrerId,
    profileId
  }) => {
    context.commit(SET_REFERRER, {
      profileId,
      referrerId
    });
  },
  [SUBSCRIBE_REFERRER]: async (context, {
    id,
    subscribers,
    referrers
  }) => {
    const [subscriber] = subscribers;
    const [referrer] = referrers;
    if (!referrer.email) {
      showToast("error", "referrerNeedsEmail");
      throw "error";
    }
    try {
      await subscribeReferrers(id, subscribers);
      context.commit(ADD_NOTIFIED_REFERRER, {
        id,
        subscriber,
        referrer
      });
    } catch (error) {
      Err.handle(error);
    }
  },
  [UNSUBSCRIBE_REFERRER]: async (context, {
    id,
    referrerId
  }) => {
    await unsubscribeReferrer(id, referrerId);
    context.commit(REMOVE_NOTIFIED_REFERRER, {
      id,
      referrerId
    });
  },
  [LOAD_TIMELINE]: async (context, {
    id,
    limit,
    offset
  }) => {
    var _context2, _context3;
    const timeLineResponse = await getTimeline(id, limit, offset);
    let unparsedTimeline = [];
    unparsedTimeline = timeLineResponse.timeline;
    const {
      timelineActivityLeft
    } = timeLineResponse;
    const clientProfile = context.state.clientProfiles.byId[id];
    const {
      timeline
    } = clientProfile;
    unparsedTimeline = _filterInstanceProperty(unparsedTimeline).call(unparsedTimeline, ({
      activityType
    }) => activityType && _includesInstanceProperty(VALID_TIMELINE_ITEMS).call(VALID_TIMELINE_ITEMS, activityType));
    context.commit(SET_TIMELINE_REMAINING, {
      timelineActivityLeft,
      id
    });
    const accountCreationItem = _findInstanceProperty(unparsedTimeline).call(unparsedTimeline, item => item.activityType === "account-creation");
    if (accountCreationItem) accountCreationItem.id = 0;
    const existingTimeline = timeline == null ? void 0 : timeline.byId;
    const unprocessedEmails = _mapInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$keys(existingTimeline)).call(_context3, key => existingTimeline[key].activityType === "email" && uuidValidate(existingTimeline[key].id) && !unparsedTimeline.some(item => item.messageId === existingTimeline[key].messageId))).call(_context2, key => existingTimeline[key]);
    unparsedTimeline = [...unparsedTimeline, ...unprocessedEmails];
    const {
      entities,
      result
    } = normalize(unparsedTimeline, [timelineSchema]);
    const idsNeedToAdd = _filterInstanceProperty(result).call(result, tid => {
      var _context4;
      if (_includesInstanceProperty(_context4 = timeline.allIds).call(_context4, tid)) return false;
      if (entities.timeline && timeline.allIds.length) {
        var _timeline$byId$tid, _entities$timeline$ti;
        return (timeline == null ? void 0 : (_timeline$byId$tid = timeline.byId[tid]) == null ? void 0 : _timeline$byId$tid.activityType) !== (entities == null ? void 0 : (_entities$timeline$ti = entities.timeline[tid]) == null ? void 0 : _entities$timeline$ti.activityType);
      }
      return true;
    });
    context.commit(SET_PROFILE_TIMELINE, {
      timeline: {
        byId: _objectSpread(_objectSpread({}, timeline.byId), entities.timeline),
        allIds: [...timeline.allIds, ...idsNeedToAdd]
      },
      id
    });
  },
  [PIN_TIMELINE_ITEM]: async (context, {
    profileId,
    id,
    pinned,
    type
  }) => {
    try {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId,
        id,
        pinned
      });
      await togglePin(profileId, type, id);
    } catch (e) {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId,
        id,
        pinned: !pinned
      });
      throw e;
    }
  },
  [ADD_NOTE]: async (context, {
    note,
    id
  }) => {
    const {
      noteId
    } = await addNote(id, note);
    const date = moment().utc().format();
    const clientProfileDetails = context.state.clientProfiles.byId[id] || {};
    const {
      boardId
    } = clientProfileDetails;
    const substitutionsNamesInfo = getSubstitutionsNamesInfo(clientProfileDetails);
    const customFieldDefinitions = context.getters[CUSTOM_FIELDS_DEFINITIONS](boardId);
    const customFields = context.getters.profileCustomFields(id);
    const detailsForSubstitution = [...substitutionsNamesInfo, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
    context.commit(ADD_TIMELINE_ITEM, {
      profileId: id,
      newItem: {
        activityType: "note",
        creator: Vue.auth.session.get().userDetails,
        id: noteId,
        note: replaceSubstitutionsTags(note, detailsForSubstitution),
        notified: false,
        pinned: false,
        updatedAt: date,
        createdAt: date
      }
    });
    return noteId;
  },
  [ADD_CHECKLIST]: async (context, {
    id,
    checklist,
    title
  }) => {
    const {
      checklistId
    } = await createChecklist(id, checklist, title);
    const date = moment().utc().format();
    context.commit(ADD_TIMELINE_ITEM, {
      profileId: id,
      newItem: {
        activityType: "checklist",
        checklist,
        title,
        creator: Vue.auth.session.get().userDetails,
        id: checklistId,
        pinned: false,
        updatedAt: date,
        createdAt: date
      }
    });
    Amplitude.logEvent("Board - checklist created", {
      page: "clients-board",
      clientProfileId: id
    });
  },
  [SEND_EMAIL_TO_CLIENT]: async (context, {
    id,
    data,
    email,
    applicationId
  }) => {
    try {
      var _context5, _context$rootGetters$, _context$rootGetters$2, _context7, _context8, _context9;
      const clientProfileDetails = context.state.clientProfiles.byId[id] || {};
      const {
        coApplicants = []
      } = clientProfileDetails;
      const {
        boardId
      } = clientProfileDetails;
      const userToSelectNames = _includesInstanceProperty(_context5 = data.toList).call(_context5, clientProfileDetails.email) ? clientProfileDetails : _findInstanceProperty(coApplicants).call(coApplicants, coApplicant => {
        var _context6;
        return _includesInstanceProperty(_context6 = data.toList).call(_context6, coApplicant.email);
      });
      data.to = data.toList;
      const {
        messageId,
        threadId,
        emailId,
        files
      } = await sendEmail(id, data, applicationId);
      const date = moment().utc().format();
      if (userToSelectNames) {
        const namesForSubstitution = getSubstitutionsNamesInfo(userToSelectNames);
        const customFieldDefinitions = context.getters[CUSTOM_FIELDS_DEFINITIONS](boardId);
        const customFields = context.getters.profileCustomFields(id);
        const detailsForSubstitution = [...namesForSubstitution, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
        data.body = replaceSubstitutionsTags(data.body, detailsForSubstitution);
      }
      const {
        givenName,
        familyName,
        email: accountEmail
      } = Vue.auth.session.get().userDetails;
      const senderEmail = (_context$rootGetters$ = (_context$rootGetters$2 = context.rootGetters["SettingsStore/DEFAULT_SYNCED_ACCOUNT_EMAIL"]) == null ? void 0 : _context$rootGetters$2.email) != null ? _context$rootGetters$ : accountEmail;
      context.commit(ADD_TIMELINE_ITEM, {
        profileId: id,
        newItem: {
          activityType: "email",
          bccList: {
            list: _mapInstanceProperty(_context7 = data.bcc).call(_context7, bccEmail => ({
              email: bccEmail,
              name: ""
            }))
          },
          body: data.body,
          ccList: {
            list: _mapInstanceProperty(_context8 = data.cc).call(_context8, ccEmail => ({
              email: ccEmail,
              name: ""
            }))
          },
          clicks: 0,
          createdAt: date,
          updatedAt: date,
          filesList: {
            files
          },
          from: `${givenName} ${familyName} <${senderEmail}>`,
          id: emailId,
          opens: 0,
          read: true,
          subject: data.subject,
          threadId: threadId ? threadId : email.threadId,
          messageId,
          toList: {
            list: Array.isArray(data.to) ? _mapInstanceProperty(_context9 = data.to).call(_context9, email => ({
              email,
              name: ""
            })) : [{
              email: data.to,
              name: ""
            }]
          },
          sendAt: data.sendAt || null
        }
      });
      return emailId;
    } catch (e) {
      Err.handle(e, {}, "failedToSendEmail");
      throw e;
    }
  },
  [ADD_FOLLOW_UP]: async (context, {
    id,
    followUp: followUpData
  }) => {
    const {
      followUpId
    } = await addFollowUp(id, followUpData);
    const date = moment().utc().format();
    const clientProfileDetails = context.state.clientProfiles.byId[id] || {};
    const {
      boardId
    } = clientProfileDetails;
    const substitutionsNamesInfo = getSubstitutionsNamesInfo(clientProfileDetails);
    const customFieldDefinitions = context.getters[CUSTOM_FIELDS_DEFINITIONS](boardId);
    const customFields = context.getters.profileCustomFields(id);
    const detailsForSubstitution = [...substitutionsNamesInfo, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
    const newReminder = {
      activityType: "follow-up",
      complete: false,
      createdAt: date,
      updatedAt: date,
      creator: Vue.auth.session.get().userDetails,
      description: replaceSubstitutionsTags(followUpData.description, detailsForSubstitution),
      id: followUpId,
      pinned: false,
      scheduledDate: followUpData.scheduledDate,
      scheduledTime: getFormattedScheduledTime(followUpData.scheduledTime),
      assignees: followUpData.assignees
    };
    context.commit(ADD_TIMELINE_ITEM, {
      profileId: id,
      newItem: newReminder
    });
    try {
      const {
        selectedBoardId
      } = context.state;
      if (selectedBoardId) {
        context.commit(ADD_BOARD_CLIENT_REMINDERS, {
          clientProfileId: id,
          reminders: [_objectSpread(_objectSpread({}, pick(newReminder, ["description", "scheduledDate", "scheduledTime", "assignees"])), {}, {
            id: _parseInt(newReminder.id)
          })]
        });
      }
    } catch (error) {
      Amplitude.logHandledError(error);
    }
  },
  [SEND_NOTE]: async (context, {
    id,
    noteId
  }) => {
    await sendNoteToReferrers(id, noteId);
    context.commit(SET_TIMELINE_ITEM_DETAILS, {
      profileId: id,
      id: noteId,
      notified: true
    });
  },
  [EDIT_NOTE]: async (context, {
    id,
    noteId,
    data
  }) => {
    const clientProfileDetails = context.state.clientProfiles.byId[id] || {};
    const {
      boardId
    } = clientProfileDetails;
    const substitutionsNamesInfo = getSubstitutionsNamesInfo(clientProfileDetails);
    const customFieldDefinitions = context.getters[CUSTOM_FIELDS_DEFINITIONS](boardId);
    const customFields = context.getters.profileCustomFields(id);
    const detailsForSubstitution = [...substitutionsNamesInfo, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
    await updateNote(id, noteId, data);
    context.commit(SET_TIMELINE_ITEM_DETAILS, {
      profileId: id,
      id: noteId,
      note: replaceSubstitutionsTags(data.note, detailsForSubstitution),
      latestUpdate: {
        timestamp: moment().utc().format(),
        user: Vue.auth.session.get().userDetails
      }
    });
  },
  [EDIT_FOLLOW_UP]: async (context, {
    id,
    followUpId,
    data
  }) => {
    const clientProfileDetails = context.state.clientProfiles.byId[id] || {};
    const {
      boardId
    } = clientProfileDetails;
    const substitutionsNamesInfo = getSubstitutionsNamesInfo(clientProfileDetails);
    const customFieldDefinitions = context.getters[CUSTOM_FIELDS_DEFINITIONS](boardId);
    const customFields = context.getters.profileCustomFields(id);
    const detailsForSubstitution = [...substitutionsNamesInfo, ...setCustomFieldsValues(customFields, customFieldDefinitions)];
    await updateFollowUp(id, followUpId, data);
    context.commit(SET_TIMELINE_ITEM_DETAILS, _objectSpread(_objectSpread({
      profileId: id,
      id: followUpId
    }, data), {}, {
      description: replaceSubstitutionsTags(data.description, detailsForSubstitution),
      latestUpdate: {
        timestamp: moment().utc().format(),
        user: Vue.auth.session.get().userDetails
      }
    }));
  },
  [EDIT_CHECKLIST]: async (context, {
    id,
    checklistId,
    data,
    title
  }) => {
    const currentChecklist = context.state.clientProfiles.byId[id].timeline.byId[checklistId].checklist;
    try {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: checklistId,
        checklist: data,
        title,
        latestUpdate: {
          timestamp: moment().utc().format(),
          user: Vue.auth.session.get().userDetails
        }
      });
      await saveChecklist(id, checklistId, data, title);
      Amplitude.logEvent("Board - checklist updated", {
        page: "clients-board",
        checklistId: data.id,
        id
      });
    } catch (error) {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: checklistId,
        checklist: currentChecklist
      });
      throw error;
    }
  },
  [DELETE_FOLLOW_UP]: async (context, {
    id,
    followUpId
  }) => {
    const followUp = context.state.clientProfiles.byId[id].timeline.byId[followUpId];
    try {
      context.commit(REMOVE_TIMELINE_ITEM, {
        profileId: id,
        id: followUpId
      });
      await deleteFollowUp(id, followUpId);
      const {
        selectedBoardId
      } = context.state;
      if (selectedBoardId) {
        context.commit(REMOVE_BOARD_CLIENT_REMINDER, {
          clientProfileId: id,
          reminderId: followUpId
        });
      }
    } catch (e) {
      context.commit(ADD_TIMELINE_ITEM, {
        profileId: id,
        newItem: followUp
      });
    }
  },
  [ADD_FOLLOW_UP_ASSIGNEES]: async (context, {
    id,
    followUpId,
    assignees
  }) => {
    const currentAssignees = context.state.clientProfiles.byId[id].timeline.byId[followUpId].assignees;
    try {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: followUpId,
        assignees: [...currentAssignees, ...assignees]
      });
      await addFollowUpAssignee(id, followUpId, assignees);
    } catch (error) {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: followUpId,
        assignees: currentAssignees
      });
      throw error;
    }
  },
  [DELETE_FOLLOW_UP_ASSIGNEES]: async (context, {
    id,
    followUpId,
    assignee
  }) => {
    const currentAssignees = context.state.clientProfiles.byId[id].timeline.byId[followUpId].assignees;
    try {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: followUpId,
        assignees: _filterInstanceProperty(currentAssignees).call(currentAssignees, username => username !== assignee)
      });
      await deleteFollowUpAssignee(id, followUpId, assignee);
    } catch (error) {
      context.commit(SET_TIMELINE_ITEM_DETAILS, {
        profileId: id,
        id: followUpId,
        assignees: currentAssignees
      });
      throw error;
    }
  },
  [DELETE_NOTE]: async (context, {
    id,
    noteId
  }) => {
    const note = context.state.clientProfiles.byId[id].timeline.byId[noteId];
    try {
      context.commit(REMOVE_TIMELINE_ITEM, {
        profileId: id,
        id: noteId
      });
      await deleteNote(id, noteId);
    } catch (e) {
      context.commit(ADD_TIMELINE_ITEM, {
        profileId: id,
        newItem: note
      });
      throw e;
    }
  },
  [DELETE_EMAIL]: async (context, {
    id,
    emailId
  }) => {
    const email = context.state.clientProfiles.byId[id].timeline.byId[emailId];
    try {
      context.commit(REMOVE_TIMELINE_ITEM, {
        profileId: id,
        id: emailId
      });
      await deleteEmail(id, emailId);
    } catch (e) {
      context.commit(ADD_TIMELINE_ITEM, {
        profileId: id,
        newItem: email
      });
      throw e;
    }
  },
  [DELETE_CHECKLIST]: async (context, {
    id,
    checklistId
  }) => {
    const checklist = context.state.clientProfiles.byId[id].timeline.byId[checklistId];
    try {
      context.commit(REMOVE_TIMELINE_ITEM, {
        profileId: id,
        id: checklistId
      });
      await deleteChecklist(id, checklistId);
    } catch (e) {
      context.commit(ADD_TIMELINE_ITEM, {
        profileId: id,
        newItem: checklist
      });
    }
  },
  [LOAD_EMAIL_TEMPLATES]: async context => {
    const {
      templates
    } = await getEmailTemplates();
    const {
      entities,
      result
    } = normalize(templates, [emailTemplatesSchema]);
    context.commit(SET_EMAIL_TEMPLATES, {
      byId: entities.emailTemplates || {},
      allIds: result
    });
  },
  [LOAD_CHECKLIST_TEMPLATES]: async context => {
    const {
      templates
    } = await getChecklistTemplates();
    const {
      entities,
      result
    } = normalize(templates, [checklistTemplatesSchema]);
    context.commit(SET_CHECKLIST_TEMPLATES, {
      byId: entities.checklistTemplates || {},
      allIds: result
    });
  },
  [CREATE_EMAIL_TEMPLATE]: async (context, {
    emailData
  }) => {
    const {
      templateId
    } = await saveEmailTemplate(emailData);
    context.commit(ADD_TEMPLATE_ITEM, {
      id: templateId,
      emailData
    });
    return templateId;
  },
  [CREATE_CHECKLIST_TEMPLATE]: async (context, {
    checklistData
  }) => {
    const {
      templateId
    } = await saveChecklistTemplate(checklistData);
    context.commit(ADD_CHECKLIST_TEMPLATE_ITEM, {
      id: templateId,
      checklistData: checklistData
    });
    return templateId;
  },
  [UPDATE_EMAIL_TEMPLATE]: async (context, {
    templateId,
    emailData
  }) => {
    await updateEmailTemplate(templateId, emailData);
    context.commit(UPDATE_TEMPLATE_ITEM, {
      id: templateId,
      emailData
    });
    Amplitude.logEvent("Board - email template updated", {
      page: "clients-board"
    });
  },
  [REMOVE_EMAIL_TEMPLATE]: async (context, {
    templateId
  }) => {
    const template = context.state.emailTemplates.byId[templateId];
    try {
      context.commit(REMOVE_TEMPLATE_ITEM, {
        id: templateId
      });
      await deleteEmailTemplate(templateId);
    } catch (error) {
      context.commit(ADD_TEMPLATE_ITEM, {
        id: templateId,
        emailData: template
      });
      throw error;
    }
  },
  [REMOVE_CHECKLIST_TEMPLATE]: async (context, {
    templateId
  }) => {
    const template = context.state.checklistTemplates.byId[templateId];
    try {
      context.commit(REMOVE_CHECKLIST_TEMPLATE_ITEM, {
        id: templateId
      });
      await deleteChecklistTemplate(templateId);
    } catch (error) {
      context.commit(ADD_CHECKLIST_TEMPLATE_ITEM, {
        id: templateId,
        checklistData: template
      });
      throw error;
    }
  },
  [ADD_CO_APPLICANT]: async (context, {
    id
  }) => {
    context.commit(ADD_CO_APPLICANT_ITEM, {
      id
    });
  },
  [REMOVE_CO_APPLICANT]: async (context, {
    id,
    index
  }) => {
    context.commit(REMOVE_CO_APPLICANT_ITEM, {
      id,
      index
    });
  },
  [UPDATE_CO_APPLICANT]: async (context, {
    id,
    index,
    payload
  }) => {
    context.commit(UPDATE_CO_APPLICANT_ITEM, {
      id,
      index,
      payload
    });
  },
  [CHANGE_PROFILE_STATUS]: async (context, {
    id,
    status
  }) => {
    try {
      const {
        selectedBoardId,
        boardsStatuses
      } = context.state;
      if (selectedBoardId) {
        var _statuses$currentStat;
        const movedProfile = context.state.clientProfiles.byId[id];
        const currentStatusLabelId = movedProfile.statusLabelId;
        const statuses = boardsStatuses[selectedBoardId].byId;
        const fromOrder = ((_statuses$currentStat = statuses[currentStatusLabelId].order) == null ? void 0 : _filterInstanceProperty(_statuses$currentStat).call(_statuses$currentStat, o => o !== id)) || [];
        const toOrder = statuses[status].order || [];
        toOrder.push(id);
        context.commit(SET_BOARD_CLIENT, {
          clientProfile: _objectSpread(_objectSpread({}, movedProfile), {}, {
            daysSinceLastActive: 0,
            statusLabelId: status,
            status
          })
        });
        context.commit(REMOVE_CHANGELOG_LAST_CHANGES, {
          clientProfileId: id
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: fromOrder,
          statusLabelId: currentStatusLabelId
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: toOrder,
          statusLabelId: status
        });
      }
    } catch (error) {
      Amplitude.logHandledError(error);
    }
    context.commit(UPDATE_STATUS_LABEL, {
      id,
      statusLabelId: status
    });
  },
  [SAVE_PROFILE_DETAILS]: async (context, {
    id
  }) => {
    var _context0;
    const details = context.state.clientProfiles.byId[id];
    const cleanDetails = cloneDeep(details);
    cleanDetails.customFields = _mapInstanceProperty(_context0 = cleanDetails.customFields).call(_context0, ({
      id,
      name,
      type,
      value
    }) => ({
      id,
      name,
      type,
      value
    }));
    DEPRECATED_CLIENT_PROFILE_DETAILS.forEach(key => delete cleanDetails[key]);
    await updateProfileDetails(id, _objectSpread(_objectSpread({}, cleanDetails), {}, {
      dateOfBirth: details.dateOfBirth || null
    }));
    context.commit(UPDATE_UPDATED_AT, {
      id,
      updatedAt: moment().format()
    });
  },
  [DELETE_CLIENT_PROFILE]: async (context, {
    id
  }) => {
    await deleteClientProfile(id);
    try {
      const {
        selectedBoardId,
        clientProfiles
      } = context.state;
      const {
        boardId
      } = clientProfiles.byId[id];
      if (selectedBoardId) {
        context.commit(REMOVE_CLIENT_PROFILE, {
          clientProfileId: id,
          boardId
        });
      }
    } catch (error) {
      Amplitude.logHandledError(error);
    }
  },
  [UPDATE_FOLLOWUP_ASSIGNEE_OWNER]: async (context, {
    id,
    followUpId,
    oldOwner,
    newOwner
  }) => {
    var _context1;
    const {
      timeline
    } = context.state.clientProfiles.byId[id];
    const followUp = cloneDeep(timeline.byId[followUpId]);
    followUp.assignees = _reduceInstanceProperty(_context1 = followUp.assignees).call(_context1, (acc, curr) => {
      if (curr === oldOwner) return [...acc, newOwner];
      if (curr === newOwner) return acc;
      return [...acc, curr];
    }, []);
    context.commit(SET_TIMELINE_ITEM_DETAILS, _objectSpread({
      profileId: id,
      id: followUpId
    }, followUp));
  },
  [UPDATE_CUSTOM_FIELDS_DATA]: async (context, {
    clientProfileId,
    customFields
  }) => {
    context.commit(SET_CUSTOM_FIELDS_DATA, {
      clientProfileId,
      customFields
    });
  },
  [MERGE_CUSTOM_FIELDS_DATA]: async (context, {
    clientProfileId,
    customFieldsDefinitions
  }) => {
    try {
      var _context$state$client;
      const currentCustomFields = cloneDeep((_context$state$client = context.state.clientProfiles.byId[clientProfileId]) == null ? void 0 : _context$state$client.customFields);
      if (!currentCustomFields) return;
      const orphanCustomFields = getOrphanCustomFields(currentCustomFields, customFieldsDefinitions);
      const mergedCustomFields = mergeCustomFields(currentCustomFields, customFieldsDefinitions);
      context.commit(SET_CUSTOM_FIELDS_DATA, {
        clientProfileId,
        customFields: [...mergedCustomFields, ...orphanCustomFields]
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_INACTIVE_CLIENTS]: async (context, {
    offset,
    limit,
    orderBy,
    orderType,
    searchString,
    boardIds
  }) => {
    try {
      context.commit(SET_INACTIVE_FILTERS, {
        orderBy,
        orderType,
        searchString,
        boardIds
      });
      const params = _objectSpread({
        offset: offset || 0,
        limit: limit || 20
      }, context.state.inactiveTable.inactiveTableFilters);
      const data = await getInactiveClients(params);
      const {
        clientProfiles,
        total
      } = data;
      const {
        entities,
        result
      } = normalize(clientProfiles, [inactiveClientSchema]);
      result.forEach(clientProfileId => {
        context.commit(SET_INACTIVE_PROFILE_STRUCTURE, clientProfileId);
      });
      context.commit(SET_INACTIVE_PROFILES, {
        inactiveClientProfiles: entities.inactiveClient,
        allIds: result,
        total,
        add: offset > 0
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadInactiveClients");
    }
  },
  [LOAD_CHANGELOG]: async (context, {
    clientProfileId,
    offset,
    limit,
    lastChanges
  }) => {
    try {
      const {
        changelog
      } = await getChangelog(clientProfileId, {
        offset,
        limit,
        lastChanges
      });
      if (lastChanges) {
        context.commit(SET_CHANGELOG_LAST_CHANGES, {
          changelog,
          clientProfileId
        });
      } else {
        context.commit(SET_CHANGELOG, {
          changelog,
          clientProfileId
        });
      }
      return {
        loadedMoreChangelog: !!(changelog != null && changelog.length)
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [DUPLICATE_CLIENT_PROFILE]: async (context, {
    clientProfileId,
    applicationId,
    labelColor,
    labelText
  }) => {
    try {
      const {
        newClientProfileId
      } = await duplicateClientProfile(clientProfileId, applicationId || null, labelText, labelColor);
      await context.dispatch(LOAD_CHANGELOG, {
        clientProfileId
      });
      return newClientProfileId;
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_EMAIL_TEMPLATE]: async (context, {
    templateId
  }) => {
    try {
      const templateData = await getTemplate(templateId);
      return templateData;
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_BOARD_CHANGELOG]: async (context, {
    boardId,
    limit,
    offset
  }) => {
    try {
      const {
        changelog
      } = await getBoardChangelog(boardId, {
        limit,
        offset
      });
      context.commit(SET_BOARD_CHANGELOG, {
        changelog
      });
      return !!(changelog != null && changelog.length);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CLIENT_PROFILES_WITH_CHANGES]: async (context, {
    boardId
  }) => {
    try {
      const {
        changelog: clientProfileIdsWithChanges
      } = await getBoardChangelog(boardId, {
        compact: true
      });
      context.commit(SET_CLIENT_PROFILES_WITH_CHANGES, {
        clientProfileIdsWithChanges
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CLIENT_PROFILE_LISTS]: async (context, clientProfileId) => {
    try {
      const {
        lists
      } = await getClientLists(clientProfileId);
      context.commit(SET_CLIENT_LISTS, {
        clientProfileId,
        lists
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CLIENT_PROFILE_CAMPAIGNS]: async (context, clientProfileId) => {
    try {
      const {
        campaigns
      } = await getClientCampaigns(clientProfileId);
      context.commit(SET_CLIENT_CAMPAIGNS, {
        clientProfileId,
        campaigns
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [MERGE_CLIENT_PROFILE]: async (context, {
    clientProfileId,
    mergeData,
    secondClientProfileId
  }) => {
    try {
      await mergeClientProfile(clientProfileId, secondClientProfileId, mergeData);
      await context.dispatch(LOAD_CHANGELOG, {
        clientProfileId
      });
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [TRANSFER_BOARD_CLIENT_PROFILES]: async (context, {
    boardId,
    currentStatusLabelId,
    toBoardId,
    toStatusLabelId = null,
    count
  }) => {
    try {
      await batchTransferClientProfiles({
        boardId,
        currentStatusLabelId,
        toBoardId,
        toStatusLabelId
      });
      if (boardId !== toBoardId) {
        context.commit(REMOVE_CLIENT_PROFILES, {
          boardId,
          statusLabelId: currentStatusLabelId
        });
        context.commit(DECREMENT_BOARD_CLIENTS, {
          boardId: boardId,
          factor: count
        });
        context.commit(INCREMENT_BOARD_CLIENTS, {
          boardId: toBoardId,
          factor: count
        });
      } else {
        var _statuses;
        const {
          selectedBoardId,
          boardsStatuses
        } = context.state;
        const statuses = boardsStatuses[selectedBoardId].byId;
        const toOrder = [...(((_statuses = statuses[toStatusLabelId || ""]) == null ? void 0 : _statuses.order) || []), ...statuses[currentStatusLabelId].order];
        const clientProfiles = context.state.clientProfiles;
        clientProfiles.allIds.forEach(clientProfileId => {
          context.commit(SET_PROFILE_STRUCTURE, clientProfileId);
        });
        context.commit(SET_BOARD_CLIENTS, {
          boardId: selectedBoardId,
          clientProfiles: _objectSpread(_objectSpread({}, clientProfiles), {}, {
            byId: _objectSpread(_objectSpread({}, clientProfiles.byId), reduce(statuses[currentStatusLabelId].order, (clientsProfilesResult, clientProfileId) => {
              clientsProfilesResult = _objectSpread(_objectSpread({}, clientsProfilesResult), {}, {
                [clientProfileId]: _objectSpread(_objectSpread({}, clientProfiles.byId[clientProfileId]), {}, {
                  daysSinceLastActive: 0,
                  statusLabelId: toStatusLabelId,
                  status: statuses[toStatusLabelId || ""].label
                })
              });
              return clientsProfilesResult;
            }, {}))
          })
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: [],
          statusLabelId: currentStatusLabelId
        });
        context.commit(SET_BOARD_STATUS_ORDER, {
          boardId: selectedBoardId,
          order: toOrder,
          statusLabelId: toStatusLabelId
        });
      }
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [MOVE_EMAIL_ATTACHMENT]: async (context, {
    clientProfileId,
    applicationId,
    emailId,
    files,
    documentRequestId,
    documentType
  }) => {
    try {
      await moveEmailAttachment(clientProfileId, applicationId, emailId, files, documentRequestId, documentType);
      showToast("success", "documentsUploaded");
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [SYNCHRONIZE_LINKED_APPLICATION]: async (context, {
    clientProfileId,
    applicationId
  }) => {
    try {
      await _Promise.all([synchronizeLinkedApplication(clientProfileId, applicationId), context.dispatch(LOAD_CHANGELOG, {
        clientProfileId
      })]);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION]: async (context, {
    clientProfileId,
    unsubscribe
  }) => {
    try {
      await changeMasterSubscription(clientProfileId, unsubscribe);
      context.commit(SET_PROFILE_MASTER_SUBSCRIBE, {
        clientProfileId,
        unsubscribe
      });
      return {
        succeeded: true
      };
    } catch (e) {
      if (e.responseJSON.code === "NotAuthorizedException") {
        showToast("error", "clientAlreadyMasterUnsubscribed");
        context.commit(SET_PROFILE_MASTER_SUBSCRIBE_AUTHOR, {
          clientProfileId,
          author: "client"
        });
      } else {
        Err.handle(e);
      }
      return {
        succeeded: false
      };
    }
  },
  [LOAD_EMAIL_BODY]: async (context, {
    clientProfileId,
    emailId
  }) => {
    try {
      const {
        body
      } = await getEmailBody(clientProfileId, emailId);
      context.commit(SET_EMAIL_BODY, {
        clientProfileId,
        emailId,
        body
      });
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [UPDATE_PROFILE_LABEL]: async (context, {
    clientProfileId,
    labelColor,
    labelText
  }) => {
    try {
      await updateProfileLabel(clientProfileId, labelText, labelColor);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  }
};
export default actions;